
import React, { useEffect, useState } from 'react';
import { Card, Form, Button } from 'react-bootstrap';
import config from '../../services/apiConfig';
import { apiPaths } from '../../services/apiPath';
import moment from 'moment';
import { predictEventDateThisYear } from '../../helper'; // make sure it's imported

const SystemWideEventSuggestions = ({ startDate, endDate, onSelectionChange }) => {
  const [events, setEvents] = useState([]);
  const [selected, setSelected] = useState({});
 
  const [predictedDates, setPredictedDates] = useState({});
  const [loadingPrediction, setLoadingPrediction] = useState({});

  const toggleInclude = (eventName) => {
    const updated = {
      ...selected,
      [eventName]: {
        ...selected[eventName],
        include: !selected[eventName]?.include,
      },
    };
    setSelected(updated);
  
    const filtered = events
      .filter(name => updated[name]?.include)
      .map(name => ({
        id: name,
        event_id: name,
        event_name: name,
        location: 'System Suggested',
        predicted_date: predictedDates[name] || null,
      }));
  
    onSelectionChange(filtered);
  };
  

  
  useEffect(() => {
    const fetchSystemSuggestions = async () => {

      try {
        const lastYearStart = moment(startDate).subtract(1, 'year').format('YYYY-MM-DD');
        const lastYearEnd = moment(endDate).subtract(1, 'year').format('YYYY-MM-DD');
        const response = await fetch(config.BASE_URI + apiPaths.adminData, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            payload: {
              body: {
                query_type: 'fetch_system_wide_event_suggestions',
                start_date: moment(startDate).format("DD MMM YYYY"),
                end_date: moment(endDate).format("DD MMM YYYY"),
                last_year_start_date: lastYearStart,
              last_year_end_date: lastYearEnd,

              }
            }
          })
        });

        const data = await response.json();
        if (data.success && Array.isArray(data.events)) {
          const initial = {};
          data.events.forEach(eventName => {
            initial[eventName] = false;
          });
          setSelected(initial);
          setEvents(data.events);
          const selectedEvents = data.events
  .filter(name => initial[name])
  .map(name => ({
    id: name,
    event_id: name,
    event_name: name,
    location: 'System Suggested',
    predicted_date: predictedDates[name] || null,
  }));

onSelectionChange(selectedEvents);
        }
      } catch (err) {
        console.error("❌ Failed to fetch system-wide suggestions:", err);
      }
    };

    if (startDate && endDate) fetchSystemSuggestions();
  }, [startDate, endDate]);

  const toggleEvent = (eventName) => {
    const updated = { ...selected, [eventName]: !selected[eventName] };
    setSelected(updated);
    const selectedEvents = events
  .filter(name => updated[name])
  .map(name => ({
    id: name,
    event_id: name,
    event_name: name,
    location: 'System Suggested',
    predicted_date: predictedDates[name] || null,
  }));

onSelectionChange(selectedEvents);
  };

  return (
    
      <div className="mt-5">
        <h5 className="fw-bold text-secondary"> Suggestions from WTT System</h5>
        {events.map((eventName, idx) => (
          <Card key={idx} className="mb-3 shadow-sm border-light">
            <Card.Body>
              <Card.Title>{eventName}</Card.Title>
  
              <Card.Subtitle className="mb-2 text-muted">
                 Predicted Date:{' '}
                {predictedDates[eventName] ? (
                  <strong>{predictedDates[eventName]}</strong>
                ) : (
                  'Not predicted yet'
                )}
              </Card.Subtitle>
  
              <Button
                variant="outline-primary"
                size="sm"
                className="me-2"
                disabled={loadingPrediction[eventName]}
                onClick={async () => {
                  setLoadingPrediction(prev => ({ ...prev, [eventName]: true }));
                
                  const predicted = await predictEventDateThisYear(eventName, "Melbourne");
                
                  setPredictedDates(prev => {
                    const updated = { ...prev, [eventName]: predicted };
                
                    // 🔁 Rerun selection sync with new predicted date
                    const selectedEvents = events
                      .filter(name => selected[name])
                      .map(name => ({
                        id: name,
                        event_id: name,
                        event_name: name,
                        location: 'System Suggested',
                        predicted_date: updated[name] || null,
                      }));
                
                    onSelectionChange(selectedEvents);
                    return updated;
                  });
                
                  setLoadingPrediction(prev => ({ ...prev, [eventName]: false }));
                }}
                
              >
                {loadingPrediction[eventName] ? 'Predicting...' : 'Predict This Year’s Date'}
              </Button>
  
              <Form.Check
                type="checkbox"
                checked={selected[eventName]}
                onChange={() => toggleInclude(eventName)}
                label="Include in schedule"
                className="mt-3"
              />
  
              <Button
                variant="info"
                className="mt-3"
                size="sm"
                onClick={() => alert(`ℹ️ No details available for "${eventName}"`)}
              >
                View Details
              </Button>
            </Card.Body>
          </Card>
        ))}
      </div>
    );
  };
  

export default SystemWideEventSuggestions;
